<trds-layout *ngIf="isLoggedIn; else notLoggedIn">
    <h1>Page not Found</h1>
</trds-layout>

<ng-template #notLoggedIn>
    <h1 class="without-layout">Page not Found</h1>
</ng-template>
